import styled from 'styled-components'
import PropTypes from 'prop-types'

const Caption4 = styled.div`
  color: #666666;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;

  ${({ textTruncate }) =>
    textTruncate &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`

Caption4.propTypes = {
  textTruncate: PropTypes.bool
}

export default Caption4



// WEBPACK FOOTER //
// ./src/components/typography/captions/Caption4.js